module.exports = __webpack_public_path__ + "static/media/Tokio-jezael-melgoza.eb50ee27.jpg";